import React from 'react';

const TESTIMONIALS = [
  {
    name: 'Sarah M.',
    location: 'New York, NY',
    text: 'Found a NYC to LA flight for $129 — way cheaper than anywhere else I checked. Booked in under 5 minutes!',
    rating: 5,
    avatar: 'SM',
    accent: 'bg-gradient-to-br from-violet-500 to-indigo-600',
  },
  {
    name: 'James T.',
    location: 'Chicago, IL',
    text: 'The non-stop filter is a lifesaver. Clean UI, fast booking, and my PNR arrived instantly.',
    rating: 5,
    avatar: 'JT',
    accent: 'bg-gradient-to-br from-orange-500 to-pink-600',
  },
  {
    name: 'Priya K.',
    location: 'San Francisco, CA',
    text: 'Compared 8 airlines in seconds. Saved $80 on my Miami trip vs. booking directly. Highly recommend!',
    rating: 5,
    avatar: 'PK',
    accent: 'bg-gradient-to-br from-teal-500 to-emerald-600',
  },
];

export default function Testimonials() {
  return (
    <section className="bg-white py-16 sm:py-24 px-4">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="inline-block bg-orange-100 text-orange-600 text-xs font-bold uppercase tracking-widest px-3 py-1 rounded-full mb-3 sm:mb-4">
            Traveler Reviews
          </span>
          <h2 className="text-3xl sm:text-4xl font-black text-gray-900">
            Loved by Travelers Across the US
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-8">
          {TESTIMONIALS.map(t => (
            <div key={t.name} className="relative bg-gray-50 rounded-3xl p-6 sm:p-8 border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300">
              <div className="text-5xl sm:text-6xl font-black text-gray-100 leading-none select-none absolute top-4 right-5 sm:right-6">"</div>

              <div className="flex gap-0.5 mb-4 sm:mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <span key={i} className="text-orange-400 text-base">★</span>
                ))}
              </div>

              <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8 relative z-10">"{t.text}"</p>

              <div className="flex items-center gap-3 sm:gap-4">
                <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-2xl ${t.accent} text-white flex items-center justify-center font-bold text-xs sm:text-sm shadow-lg`}>
                  {t.avatar}
                </div>
                <div>
                  <p className="font-bold text-gray-900 text-sm sm:text-base">{t.name}</p>
                  <p className="text-gray-400 text-xs sm:text-sm">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Rating summary */}
        <div className="mt-10 sm:mt-16 bg-gradient-to-r from-[#080c1a] to-[#0f1628] rounded-2xl sm:rounded-3xl p-6 sm:p-8 flex flex-col sm:flex-row items-center justify-between gap-6 text-white">
          <div className="text-center sm:text-left">
            <p className="text-4xl sm:text-5xl font-black">4.9<span className="text-xl sm:text-2xl text-white/40">/5</span></p>
            <div className="flex gap-1 mt-2 justify-center sm:justify-start">
              {Array.from({ length: 5 }).map((_, i) => (
                <span key={i} className="text-orange-400 text-lg sm:text-xl">★</span>
              ))}
            </div>
            <p className="text-slate-400 text-xs sm:text-sm mt-1">Based on 18,000+ reviews</p>
          </div>
          <div className="grid grid-cols-3 gap-6 sm:gap-10 text-center">
            {[
              { v: '98%',  l: 'Satisfaction Rate' },
              { v: '2M+',  l: 'Happy Travelers' },
              { v: '3min', l: 'Avg. Booking Time' },
            ].map(s => (
              <div key={s.l}>
                <p className="text-xl sm:text-2xl font-black text-white">{s.v}</p>
                <p className="text-slate-500 text-xs mt-1">{s.l}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
